import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-illustrations',
    templateUrl: './illustrations.component.html',
    styleUrls: ['./illustrations.component.css']
})
export class IllustrationsComponent implements OnInit {
    private navCards = [
        { title: 'Create Illustration', description: 'Design a Healthcare, Social Security, Medicare Means Testing, or Long-Term Care illustration', icon: 'fa-bar-chart', color: '#ece6fa', iconColor: '#9b78e1', image:'../../../assets/icons/illustration.svg', isCreateReport: true },
        { title: 'View Past Illustration', description: 'All illustrations are stored in one convenient location', icon: 'fa-recycle', color: '#ccf4f2', iconColor: '#00c4c2', image:'../../../assets/icons/past_illustration.svg', isCreateReport: true  },
        { title: 'Download Report', description: 'Add a new client to the portal in order to create an illustration', icon: 'fa-file', color: '#fedede', iconColor: '#fe4e4e', image:'../../../assets/icons/download_report.svg', isCreateReport: true  },
    ]

    constructor() {

    }

    ngOnInit() {
    }

}
